import Typography from '@mui/material/Typography'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import Box from '@mui/material/Box'

import { getRefreshToken } from 'shared/utils/helpers/refreshToken'
import { useQueryClient } from 'react-query'

export default function PaymentCompleted() {
   const navigate = useNavigate()
   const queryClient = useQueryClient()
   const { t } = useTranslation('UNAUTHORIZED')

   useEffect(() => {
      setTimeout(() => {
         getRefreshToken(queryClient).then(() => {
            setTimeout(() => {
               navigate('/dashboard')
            }, 5000)
         })
      }, 4000)
   }, [])

   return (
      <Box
         sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            maxWidth: '40%',
            m: '0 auto',
            height: '100%',
            justifyContent: 'center',
            textAlign: 'center',
         }}
      >
         <Typography variant="h2" color="primary">
            {t('paymentCompleted.header')}
         </Typography>
         <Typography variant="h3" sx={{ fontWeight: 'normal' }} color="text.secondary">
            {t('paymentCompleted.content')}
         </Typography>
      </Box>
   )
}
